<template>
  <v-select
    :value="value"
    :options="couriers"
    :reduce="(courier) => courier"
    label="first_name"
    placeholder="Courier.."
    :searchable="true"
    :filter-by="filterCouriers"
    @input="$emit('input', $event)"
  >
    <template #selected-option="courier">
      <div class="selected-courier">
        {{ courier.first_name }}
      </div>
    </template>

    <template #option="courier">
      <div class="courier-option">
        <CImg :src="courier.image_icon || courier.gravatar" class="courier-avatar" placeholderColor="lightgray" />
        <span>{{ courier.first_name }} #{{ courier.id }}</span>
      </div>
    </template>

    <template #no-options>
      <div class="text-muted p-2">No couriers found</div>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'CourierSelect',
  props: {
    value: { type: Object, default: null },
    couriers: { type: Array, required: true },
  },
  methods: {
    filterCouriers(option, label, search) {
      const searchLower = search.toLowerCase();
      const firstName = option.first_name.toLowerCase();
      const courierId = option.id.toString();

      return firstName.includes(searchLower) || courierId.includes(search);
    }
  }
};
</script>

<style scoped>
.courier-option {
  display: flex;
  align-items: center;
  color: #5856d6;
  font-weight: 600;
  padding: 4px 0;
}

.courier-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
  object-fit: cover;
}

.selected-courier {
  display: flex;
  align-items: center;
  gap: 4px;
}

:deep(.vs__dropdown-option) {
  padding: 4px 8px;
}

:deep(.vs__dropdown-option--highlight) {
  background: rgba(88, 86, 214, 0.1);
  color: #5856d6;
}
</style>
